import React, { useState, useContext } from "react";
import {
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBNavbarLink,
    MDBIcon,
    MDBTooltip
} from "mdb-react-ui-kit";
import useAxiosCall from "../../../Hooks/useAxiosCall";
import Toast from "../../../Components/Toast";
import { encryptData } from "../../../Utilities/CryptoUtility";
import { UserContext } from '../../../Context/UserContext';
import { escapeRegExp } from "../../../Common";
import { SecureStorage } from '../../../Utilities/StorageEncryption';
const ExportDropdown = ({ noMargin, portalType, filters, label }) => {

    const [toastData, setToastData] = useState({ type: "", message: "", isOpen: false });
    const { makeApiCall } = useAxiosCall();
    const { user } = useContext(UserContext);

    const handleApiCallSuccess = (data) => {
        setToastData({ type: "success", message: data.message, isOpen: true, position: 'top-right' });
    };

    const handleApiCallError = (errorMessage) => {
        setToastData({ type: "danger", message: errorMessage, isOpen: true, position: 'top-right' });
    };


    const exportResident = async (fileType) => {
        
        let domain = SecureStorage.getItem('domain');
        const cookieName = `${escapeRegExp(`${user.name}-${domain}-${portalType}`)}-selectedColumns`;
        const cookieExists = document.cookie.indexOf(`${user.name}-${domain}-${portalType}-selectedColumns=`) !== -1;
        let selectedColumns = "";
        const cookieValue = document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${escapeRegExp(cookieName)}\\s*=\\s*([^;]*).*$)|^.*$`), "$1");

        if (cookieExists) {
            selectedColumns = JSON.stringify(cookieValue );
        }
        const requestData = {
            data: encryptData(JSON.stringify(
                {
                    company: SecureStorage.getItem('companyKey'),
                    domain: SecureStorage.getItem('domain'),
                    fileType: fileType,
                    portalType: portalType,
                    sortColumn:filters.sortColumn,
                    sortDirection:filters.sortDirection,
                    searchValues:filters.searchValues,
                    pastResident:filters.pastResidents,
                    selectedColumn: selectedColumns,
                    notificationLabel: label
                }
            ))
        };
        await makeApiCall({
            requestData,
            onSuccess: handleApiCallSuccess,
            onError: handleApiCallError,
            requestType: 'POST',
            url: "exportReport"
        });
    }

    const handleClick = (exportType) => {
        exportResident(exportType);
    }

    const resetToastData = () => {
        setToastData({ type: "", message: "", isOpen: false });
    }

    return (
        <>
            <Toast toast={toastData} resetToast={resetToastData} hasHeader={false} />
            <MDBDropdown className={noMargin ? "" : "ms-3"}>
                <MDBDropdownToggle style={{ cursor: "pointer" }}
                    tag="a"
                    className="nav-link hidden-arrow d-flex align-items-center">
                    <MDBTooltip tag='span' title="Export">
                        <MDBIcon fas icon="file-export" style={{marginRight: '15px' }} />
                    </MDBTooltip>
                </MDBDropdownToggle>
                <MDBDropdownMenu style={{ zIndex: 1060 }}>
                    <MDBDropdownItem className="m-2">
                        <MDBNavbarLink onClick={() => handleClick('csv')}>Export as CSV</MDBNavbarLink>
                    </MDBDropdownItem>
                    <MDBDropdownItem className="m-2">
                        <MDBNavbarLink onClick={() => handleClick('pdf')}>Export as PDF</MDBNavbarLink>
                    </MDBDropdownItem>
                    <MDBDropdownItem className="m-2">
                        <MDBNavbarLink onClick={() => handleClick('xlsx')}>Export as Excel</MDBNavbarLink>
                    </MDBDropdownItem>
                </MDBDropdownMenu>
            </MDBDropdown>
        </>
    );
};

export default ExportDropdown;
